"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * DatabaseControllers are used to encapsulate database actions and can in some cases be seen as implementations of the
 * decorator pattern ( https://wiki.python.org/moin/DecoratorPattern ). In other cases it's just encapsulation.
 */
const bson_objectid_1 = require("bson-objectid");
const basic_1 = require("../basic");
const DataController_1 = require("../datastructures/DataController");
const exceptions_1 = require("../exceptions");
class DatabaseController extends DataController_1.default {
    constructor(id) {
        super();
        this.setId(id);
    }
    getId() {
        return this._id;
    }
    getSid() {
        return this._id.toHexString();
    }
    setId(id) {
        if (!basic_1.isValidId(id)) {
            throw exceptions_1.ID_EXCEPTION;
        }
        this._id = new bson_objectid_1.default(id);
    }
}
__decorate([
    DataController_1.default.dataProperty()
], DatabaseController.prototype, "_id", void 0);
exports.default = DatabaseController;
//# sourceMappingURL=DatabaseController.js.map